let ContainerMixin = (superClass) => class extends superClass {

    setupContainer() {
        if (top.location.href.match(/#debug$/i)) {
            this.debug = true;
        }
        if (top.location.href.match(/#superdebug$/i)) {
            this.superDebug = true;
        }

        let initialize = (e) => {
            if(!this.constructor.INIT_DONE) {
                this.initialize();
                this.constructor.INIT_DONE = true;
            }
            this.onReady(e);
        };

        if(typeof(jQuery) !== "undefined") {
            jQuery(document).ready((e) => {
                initialize(e);
            });
        } else if (window.addEventListener) {
            window.addEventListener("load", () => initialize())
        } else {
            window.onload = () => initialize()
        }
    }

    /**
     * Initialize is run only once
     * It can be used as a static initializer
     * https://stackoverflow.com/questions/335311/static-initializer-in-java
     */
    initialize() {}
    /**
     * Fired when the document has loaded
     * @param e
     */
    onReady(e) {}
};

export default ContainerMixin;


// WEBPACK FOOTER //
// /data/php7/vendor/etouches/ecore/es6/base/ContainerMixin.es6